import React, { useState, useEffect } from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { OTP, REFERRER } from "app/utils/constants/endPoint";
import { requestApi } from "app/utils/RestApi";
import Swal from "sweetalert2";
import { AUTH_SAVE } from "app/redux/actions/constant";
import { useWindowPaste } from "app/hooks/useWindowPaste";
import OTPCountdown from "app/components/OTPCountdown";
import { useProgram } from "app/hooks/useProgram";
import TopNavBar from "app/components/TopNavBar/TopNavBar";
import { decryptData } from "app/utils/appHelpers";
import { ERROR_SERVER_DEFAULT } from 'app/utils/appHelpers';
import Footer from 'app/components/Footer';

const MicrositeOtp = (props) => {
	const pasteValue = useWindowPaste();

	const program = useProgram();

	const navigate = useNavigate();
	const location = useLocation();

	const TOTAL_INPUTS = 6;

	let attempt = 0;

	const [otp, setOtp] = useState(Array(TOTAL_INPUTS).fill(''));
	const otpInputRefs = Array(TOTAL_INPUTS).fill(0).map(() => React.createRef());
	const handleOtpChange = (otpValue, index) => {
		if (String(otpValue).length <= 1) {
			const otpValues = [...otp];
			otpValues[index] = otpValue;
			setOtp(otpValues);

			if (String(otpValue).length === 1 && index !== TOTAL_INPUTS - 1) {
				otpInputRefs[index + 1].current.focus();
			}
		}
	};

	const handlePaste = (value) => {
		if (String(value).length === 6 && (new RegExp(/^\d+$/).test(value))) {
			const otpValues = value.split('');
			setOtp(otpValues);
			otpInputRefs[otpValues.length - 1].current.focus();
		}
	}

	useEffect(() => {
		handlePaste(pasteValue);
	}, [pasteValue])

	// const handleKeyDown = (event, index) => {
	// 	if (event.keyCode === 8 && !otp[index]) {
	// 		otpInputRefs[index - 1].current.focus();
	// 	}
	// };

	React.useEffect(() => {
		if (localStorage.getItem('success_otp') == "1") {
			navigate("/micrositeKonfirmasiBelumRegis");
		} else {
			localStorage.setItem('success_otp', "0")
		}
		otpInputRefs[0].current.focus();
	}, [localStorage]);

	const backHandler = () => {
		navigate(-1);
	};

	function clearCache() {
		const actionTypes = ['TNC_REGIS', 'LOGIN', 'PROFILE_EDIT'];
		actionTypes.forEach(at => {
			localStorage.removeItem(`ref_otp_exp_${at}`);
			localStorage.removeItem(`expiryTime_${at}`);
			localStorage.removeItem(`restartCount_${at}`);
			localStorage.removeItem(`restartAvailableTime_${at}`);
		});
		// legacy keys
		localStorage.removeItem('ref_otp_exp');
		localStorage.removeItem('otp_action_type');
		localStorage.removeItem('expiryTime');
		localStorage.removeItem('restartCount');
		localStorage.removeItem('restartAvailableTime');
		localStorage.removeItem('edit_profile_referrer');
		localStorage.removeItem("temp_token");
	}

	const getValidEditProfileData = () => {
		const raw = localStorage.getItem("edit_profile_referrer")
		if (!raw) return null;
		let data = null;
		try {
			const parsed = JSON.parse(raw)
			if (parsed && typeof parsed === 'object') data = parsed;
		} catch (e) {
			data = null;
		}
		if (!data) return null;
		const userdata = JSON.parse(localStorage.getItem('userdata') || 'null')
		const currentId = userdata?.userLoggedin?.id
		if (currentId == null || Number(data.id) !== Number(currentId)) {
			localStorage.removeItem("edit_profile_referrer")
			return null;
		}
		return data;
	}

	const onSubmitOtp = async () => {
		const profileEditData = getValidEditProfileData()


		if (!otp.some(s => !s)) {
			await Swal.fire({
				title: 'Mohon Tunggu..',
				timerProgressBar: true,
				didOpen: () => {
					Swal.showLoading()
					requestApi(OTP.VERIFY_OTP_REF, {
						data: {
							username: localStorage.getItem('username'),
							otp: otp.join(''),
							actionType: getActionType()
						}
					}).then(({ data }) => {
						if (data.status == 'success') {
							const otpOnly = localStorage.getItem("otpOnly");
							if (profileEditData != null) {
								requestApi(REFERRER.EDIT['03'], {
									data: profileEditData
								}).then(({ data }) => {
									Swal.close();
									if (data?.status === 'success') {
										clearCache()
										navigate('/micrositeProfile');
										Swal.fire({
											icon: 'success',
											text: 'Data berhasil disimpan'
										});
									}
								}).catch(err => {
									Swal.close();
									if (err?.data) {
										var arrayError = [];
										for (let [key, value] of Object.entries(err.data)) {
											arrayError.push(value)
										}
										var errorJoin = arrayError.join('<br>');

										Swal.fire({
											icon: 'error',
											text: errorJoin
										});
									} else if (err?.message) {
										Swal.fire({
											icon: 'error',
											text: err.message
										});
									} else {
										Swal.fire({
											icon: 'error',
											text: 'Bad request'
										});
									}
								})

							} else if (otpOnly) {
								clearCache()
								Swal.close();
								localStorage.removeItem('otpOnly')
								navigate('/micrositeNews')
							} else {
								requestApi(REFERRER.AGREE_TNC_REF, {
									params: {
										email: localStorage.getItem('username')
									}
								}).then(({ data }) => {
									Swal.close();
									if (data?.status === 'success') {
										let ls_user = JSON.parse(localStorage.getItem('userdata'))
										localStorage.setItem('userdata', JSON.stringify({
											...ls_user,
											isRegistered: true
										}))

										const { isVerified } = ls_user

										clearCache()
										if (isVerified) {
											navigate('/micrositeNews')
										} else {
											navigate('/micrositeKonfirmasiBelumRegis')
										}
										// window.history.replaceState(null, null, "/micrositeKonfirmasiBelumRegis");
										// window.location.href = '/micrositeKonfirmasiBelumRegis'
									}
								}).catch(err => {
									Swal.close();
									console.log(err);
									setTimeout(() => {
										Swal.fire({
											icon: 'warning',
											text: err?.message ?? err?.data?.message ?? 'Terjadi kesalahan, silakan coba lagi',
											allowOutsideClick: false,
											confirmButtonColor: 'red'
										})
									}, 1000);
								})
							}
						} else {

							Swal.close();
							setTimeout(() => {
								Swal.fire({
									icon: 'warning',
									text: data?.message || 'Kode OTP tidak valid',
									allowOutsideClick: false,
									confirmButtonColor: 'red'
								})
							}, 1000);
						}
					}).catch(err => {
						setTimeout(() => {
							Swal.fire({
								icon: 'warning',
								text: err?.message ?? err?.data?.message ?? 'Kode OTP tidak valid',
								allowOutsideClick: false,
								confirmButtonColor: 'red'
							})
						}, 1000);
					})
				},
				showCloseButton: false,
				showConfirmButton: false,
				allowOutsideClick: false
			})
		}
	}

	const getActionType = () => {
		if (getValidEditProfileData()) return "PROFILE_EDIT";
		if (localStorage.getItem("otpOnly")) return "LOGIN";
		return "TNC_REGIS";
	}

	const resetOtp = () => {
		setOtp(Array(TOTAL_INPUTS).fill(''))
	}


	return (
		<Div className={location.pathname !== '/micrositeOtp' ? 'page-wrapper' : 'custompage'}>
			{
				location.pathname !== '/micrositeOtp' &&
				<TopNavBar activeMenu={1} />
			}
			<ContentWrapper>
				<Div className='content-padding'>
					<Div className='back-icon'>
						<KeyboardBackspaceIcon onClick={backHandler} />
					</Div>
					<Div className='flex-justify-center-title '>
						<Typography fontSize={24} fontWeight={600} color={"#C21B17"}> Verifikasi OTP</Typography>
					</Div>

					<Div className='mt-2'>
						<Div className='p-4'>
							<Typography fontSize={16} fontWeight={600} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>OTP telah dikirimkan ke Email yang terdaftar pada {program}</Typography>
							<Div sx={{ mb: 2, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
								{Array(TOTAL_INPUTS).fill(0).map((_, index) => (
									<input
										autoComplete="off"
										style={{
											width: '40px',
											height: '40px',
											maxHeight: '40px',
											// adjust text alignment and font size as needed
											textAlign: 'center',
											fontSize: '20px',
											margin: 6,
											borderRadius: 6,
											borderColor: "#eee"
										}}
										key={index}
										type="number"
										name={`otp_${index}`}
										onChange={(e) => {

											if (e.target.value == 'e') {
												return
											}
											if (e.nativeEvent.inputType !== "insertFromPaste") {
												handleOtpChange(e.target.value, index);
											}
											if (e.nativeEvent.inputType === "deleteContentBackward") {
												if (index !== 0) {
													otpInputRefs[index - 1].current.focus();
												}
											}
										}}
										onKeyDown={(e) => {
											if (e.keyCode === 69) e.preventDefault()
										}}
										maxLength="1"
										ref={otpInputRefs[index]}
										value={otp[index]}
									/>
								))}
							</Div>

							<OTPCountdown actionType={getActionType()} onRestart={() => resetOtp()} />

						</Div>
					</Div>

					<Div className='flex-justify-center' sx={{ mt: 2 }}>
						<ButtonStyled
							disabled={otp.some(s => !s)}
							onClick={onSubmitOtp}
							btnText={"Kirim"}
							preset={"primary"}
							sx={{ maxWidth: '451px' }}
						/>
					</Div>


				</Div>
			</ContentWrapper>
			<Footer />
		</Div>

	);
};




const mapStateToProps = state => ({
	authMicrosite: state.authMicrosite
});

export default connect(mapStateToProps)(MicrositeOtp);